import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'lodash-es';


@Pipe({
  name: 'unsortedKeyValue'
})
export class UnsortedKeyValuePipe implements PipeTransform {

  transform(objectValue: object, ...args: unknown[]): unknown {
    const entries = map(objectValue, (value, key) => ({key, value}))
    return entries;
  }

}
